/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for Notification container;
 *   Integrations : 28-09-2022
 *   Version : v1.0
 *   Created : 28-08-2022
*/

/*import packages*/
import { useEffect, useState } from 'react';
import { Modal } from 'bootstrap';

/*import components*/
import { Input } from '../../components/input/index';
import { PrimaryBtn, TextBtn } from '../../components/cta/index';
import { Loader } from '../../components/loader';
import { Toast } from '../../components/note';
import UpdateJSON from '../../components/modal/updateJSON';

/*import services */
import APIGet from '../../services/getApi';
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';

const Index = () => {

    const [allocation, setAllocation] = useState(null);
    const [error, setError] = useState(null);
    const [loader, setLoader] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [configData, setConfigData] = useState([]);
    const [editableConfig, setEditableConfig] = useState(null);
    const [openJSONModal, setOpenJSONModal] = useState(false);
    const [jsonData, setJsonData] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        getInflationData(true);

    }, []);

    useEffect(() => {
        if (openJSONModal) {
            var myModal = new Modal(document.getElementById("update-json"), {});
            myModal.show();
        }
    }, [openJSONModal])

    useEffect(() => {
        if (error !== null) {
            setTimeout(() => {
                setError(null)
            }, 3000)
        }
    }, [error])

    useEffect(() => {
        if (success !== null) {
            setTimeout(() => {
                setSuccess(null)
            }, 3000)
        }
    }, [success])

    useEffect(() => {
        setTimeout(() => {
            setError(null);
        }, 3000);
    }, [error]);

    /*----- get inflation api -*/
    const getInflationData = (status) => {
        setLoader(status);
        let url = devconfig.admin + "/config/get";
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                setLoader(false)
                let arr = response.data.filter((item) => item.type === "INFLATION")
                setAllocation(arr[0]["allocation"]);
                if (response.data) {
                    setConfigData(response.data);
                }
            } else {
                setAllocation(null);
                setLoader(false);
            }
        })
    }

    /* ---- update inflation ----*/
    const updateConfig = (config) => {
        setSubmitLoader(true);

        let url = devconfig.admin + "/config/update";

        let data = JSON.stringify({
            type: config.type,
            allocation: config.allocation
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                let text = config.type === "upi_limit_per_day" ? "UPI limit per day" : "upi_limit_per_transaction" ? "UPI limit per transaction" : config.type.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
                setSuccess(`${text} updated`);
                setEditableConfig(null);
            } else {
                setError(response.message);
                setSubmitLoader(false);
            }
        })
    }
    return (
        <div className="row e-notification">
            <div className="col-lg-6">
                <div className="card border-0 e-dashboard-card pt-4 px-4 pb-2">
                    {
                        loader ?
                            <Loader />
                            :
                            <>
                                <div className="col-lg-12  mb-3">
                                    <h5 className='e-notification-form-title'>Inflation</h5>
                                </div>
                                <div className='row px-2'>
                                    {
                                        configData.length ?
                                            <>
                                                {
                                                    configData.map((item, key) => {
                                                        return (
                                                            <div className='row'>
                                                                <div className="col-lg-10 mb-2">
                                                                    <label className='text-capitalize'>{`Enter the ${item.type
                                                                        .replace(/_/g, ' ')
                                                                        .replace(/\bupi\b/gi, 'UPI')
                                                                        .trim()}`}</label>
                                                                    {
                                                                        editableConfig === item.type ?
                                                                            <Input
                                                                                placeholder={`Enter the ${item.type
                                                                                    .replace(/_/g, ' ')
                                                                                    .replace(/\bupi\b/gi, 'UPI')
                                                                                    .trim()}`}
                                                                                value={item.allocation}
                                                                                type="text"
                                                                                className="e-notification-form-element"
                                                                                valueChange={(temp) => {
                                                                                    const updatedConfig = [...configData];
                                                                                    updatedConfig[key] = {
                                                                                        ...updatedConfig[key],
                                                                                        allocation: temp,
                                                                                    };
                                                                                    setConfigData(updatedConfig);
                                                                                }}
                                                                            />
                                                                            :
                                                                            <p className='e-truncate'>{item.allocation ? item.allocation.toLocaleString('EN-in') : '-'}</p>
                                                                    }

                                                                </div>
                                                                <div className='col-2 d-flex align-items-center justify-content-center'>
                                                                    {
                                                                        item.type === "min_investment_basket" ?
                                                                            <TextBtn name={item.type === editableConfig ? "Update" : "Edit"}
                                                                                handleClick={() => { setJsonData(item); setOpenJSONModal(true) }} />
                                                                            :
                                                                            <TextBtn name={item.type === editableConfig ? "Update" : "Edit"}
                                                                                handleClick={() => {
                                                                                    if (item.type === editableConfig) {
                                                                                        updateConfig(item);
                                                                                        return;
                                                                                    }
                                                                                    setEditableConfig(item.type)
                                                                                }} />
                                                                    }

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </>
                                            :
                                            null
                                    }


                                    {/* <div className="col-lg-12 text-end mb-3 ">
                                        {
                                            allocation ?
                                                <PrimaryBtn
                                                    name="Edit"
                                                    className={submitLoader ? "e-notification-form-btn e-btn-loader mt-5" : "e-notification-form-btn mt-5"}
                                                    handleClick={() => {
                                                        updateInflation()
                                                    }}
                                                />
                                                :
                                                <PrimaryBtn
                                                    name="Edit"
                                                    className="e-disabled mt-5"
                                                />
                                        }
                                    </div> */}
                                </div>
                            </>
                    }
                </div>
                {/* Error toast */}
                {
                    error !== null ?
                        <Toast data={error}
                            type="error"
                            id="1" />
                        :
                        null
                }

                {/* Success toast */}
                {
                    success !== null ?
                        <Toast data={success}
                            type="success"
                            id="2" />
                        :
                        null
                }

            </div>
            {
                openJSONModal ?
                    <UpdateJSON data={jsonData}
                        close={() => setOpenJSONModal(false)}
                        success={() => { setOpenJSONModal(false); getInflationData() }} />
                    :
                    null
            }
        </div>
    );
}

export default Index;